import { useUserClientContext } from '@/app/clientContext';
import { useClientCodeFromUrl } from './useClientCodeFromUrl';

export const useActiveClientCode = (): string | undefined => {
  const { canClientSwitch, context } = useUserClientContext();
  const urlClientCode = useClientCodeFromUrl();

  if (canClientSwitch) {
    return urlClientCode || context.code || undefined;
  }

  return context.code || undefined;
};
